import { useMapState } from '@ais-ui/react-openlayers';
import { useEffect, useState } from 'react';
import { useReplayContext } from './ReplayContext';

export const useIsReplayDisabled = () => {
  const { currentZoom } = useMapState();
  const { startDate, minZoom } = useReplayContext();
  const [isDisabled, setIsDisabled] = useState(true);
  const [disableReason, setDisableReason] = useState('');

  useEffect(() => {
    if (!startDate) {
      setIsDisabled(true);
      setDisableReason('Start date not selected');
      return;
    }

    if (currentZoom === null || currentZoom === undefined) {
      setIsDisabled(true);
      setDisableReason('Cannot determine zoom level');
      return;
    }

    if (currentZoom < minZoom) {
      setIsDisabled(true);
      setDisableReason('Zoom in to start replay');
      return;
    }

    setIsDisabled(false);
    setDisableReason('');
  }, [startDate, currentZoom, setIsDisabled, setDisableReason, minZoom]);

  return { isDisabled, disableReason };
};
